import { useIsMutating, useMutation, useQueryClient } from '@tanstack/react-query';
import { setUserExamCategory } from '../services/examCategoryService';

export const EXAM_SELECTION_MUTATION_KEY = ['setUserExamCategory'];
const EXAM_DEPENDENT_QUERIES = new Set([
  'dashboardHeaderData', 'dashboardContentData', 'dashboardStatsData',
  'dashboardCategories', 'masterExamCategories',
  'states', 'examCategories', 'signupExamCategories', 'examsByCategory',
  'favoriteCategories', 'sidebarData', 'profileSettingsProfile',
  'notifications', 'todayDailyQuestion',
]);

export function useIsExamSelectionPending() {
  return useIsMutating({ mutationKey: EXAM_SELECTION_MUTATION_KEY }) > 0;
}

export function useSetUserExamCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: EXAM_SELECTION_MUTATION_KEY,
    mutationFn: setUserExamCategory,
    onSuccess: async () => {
      const filters = { predicate: query => EXAM_DEPENDENT_QUERIES.has(query.queryKey[0]) };
      // Stop requests started under the previous exam before loading the new context.
      await queryClient.cancelQueries(filters);
      // Clear old exam data, refetch mounted sections, and leave unmounted variants
      // empty so their next visit cannot reuse the previous exam's fresh cache.
      await queryClient.resetQueries(filters);
    },
  });
}
